import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { Keyboard } from "lucide-react"

const buttonSchema = z.object({
  name: z.string().min(1, "Name is required"),
  type: z.enum(["inline", "reply"]).optional(),
  buttons: z.string().optional(),
})

const buttonColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "name", type: "text", options: { label: "Name" } },
  { key: "type", type: "status", options: { label: "Type" } },
  { key: "buttons", type: "text", options: { label: "Buttons" } },
  { key: "updated_at", type: "date", options: { label: "Updated" } },
]

const buttonFormFields = [
  { name: "name", label: "Name", type: "text", placeholder: "Enter keyboard name" },
  {
    name: "type",
    label: "Type",
    type: "select",
    options: [
      { value: "inline", label: "Inline" },
      { value: "reply", label: "Reply" },
    ],
  },
  { name: "buttons", label: "Buttons (JSON)", type: "textarea", placeholder: '[{"text":"Click","callback_data":"click"}]' },
]

export default function ButtonsPage() {
  return (
    <ResourcePage
      resource="ui/keyboards"
      title="Buttons"
      icon={Keyboard}
      columns={buttonColumns}
      formFields={buttonFormFields}
      formSchema={buttonSchema}
    />
  )
}
